<template>
  <div>
<!--    <div class="header">-->
<!--      {{ $store.state.shop.name }}-->
<!--    </div>-->

    <!-- 居中 -->
    <van-row type="flex" justify="center" align="center" :style="'margin-top:10rem;'">
      <van-col span="8"  :style="'text-align:center'">
        <van-icon name="warning" color="lightblue" size="8rem" />
      </van-col>
    </van-row>
    <template v-if="errorType=='MenuPermission'">
      <van-row type="flex" justify="center" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <van-col span="24">
          <span v-if="name!='undefined'">{{role!='undefined'?role:''}}没有“{{name}}”权限<br>请超级管理员前往到管理后台添加菜单权限<br>添加菜单权限步骤：人员-权限管理-工作台菜单权限</span>
          <span v-else>{{role!='undefined'?role:''}}没有菜单权限<br>请前往超级管理员管理后台添加菜单权限</span>
        </van-col>
      </van-row>
      <van-row type="flex" justify="center" :style="'margin-top:3rem;text-align:center'">
        <van-col span="12">
          <van-button round style="background-color: #1989fa;color: white" @click="toShopHome()">回到首页</van-button>
        </van-col>
      </van-row>
    </template>
    <template v-else-if="errorType=='ClerkDisabled'">
      <van-row type="flex" justify="center" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <van-col span="24">
          <span>您已被下架，没有权限访问</span>
        </van-col>
      </van-row>
    </template>
    <template v-else-if="errorType=='ClerkResigned'">
      <van-row type="flex" justify="center" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <van-col span="24">
          <span>您已离职，需要复职请联系店铺管理员。</span>
        </van-col>
      </van-row>
    </template>

    <template v-else>
      <van-row type="flex" justify="center" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <van-col span="24">
          {{$store.state.shop.id == 123 ? '您还不是店员' : '您还不是店员，点击按钮申请'}}
        </van-col>
      </van-row>

      <van-row type="flex" justify="center" :style="'margin-top:3rem;text-align:center;color:black'" >
        <van-col span="12">
          <van-button v-if="$store.state.shop.id == 123" round type="primary" @click="toUserMy()">个人中心</van-button>
          <van-button v-else round type="primary" @click="toClerkApply()">成为店员</van-button>
        </van-col>
      </van-row>

      <van-row type="flex" justify="center" :style="'margin-top:1rem;text-align:center'">
        <van-col span="12">
          <van-button round @click="toUserHome()" >下单聊天</van-button>
        </van-col>
      </van-row>
    </template>



  </div>
</template>
<script>
import Vue from "vue";
import {Col, Row, Image as VanImage, Button, Icon, Toast} from 'vant';
import {getUserDomain} from "@/api/shop";

Vue.use(Icon);
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(VanImage)
export default {
  name: 'noAccount',
  data() {
    return {
      domain: null,
      errorType:null,
      name:null,
      role:null,
    };
  },
  components: {

  },
  methods: {
    toClerkApply: function(){
      this.go('/clerk/apply')
    },
    toUserHome: function(){
      this.go('');
    },
    toShopHome:function (){
      this.$router.push("/")
    },
    toUserMy: function(){
      this.go('/my/index');
    },
    go: function (path){
      window.location.href = this.domain + path;
    },
  },
  mounted() {
    Toast.loading()
    getUserDomain().then(res=>{
      this.domain = res.data.domain
    }).finally(()=>{
      Toast.clear()
    })
    this.errorType=this.$route.query.type
    this.name=this.$route.query.name
    this.role=this.$route.query.role
  }
}
</script>

<style lang="less" scoped>

.header {
  padding: 20px 15px;
  background: #04ade0;
  text-align: center;
  font-size: 22px;
  color: #fff;
  letter-spacing: 1px;
}
</style>
